import { useState, useEffect, useCallback } from "react";
import { IRecords, ViewType } from "../../../types";
import MultiSelectDropdown from "../../dropdown/dropdown";
import { getAllowedBreakeven } from "../../../calculations/strategyUtils";
import refreshIcon from "./../../../images/refresh.svg";
interface IUserViewProps {
  data: IRecords;
  onViewSelected: Function;
  indexName: string;
  onRefresh: () => void;
  expiryDates: string[]
}
const UserView = ({
  data,
  onViewSelected,
  indexName,
  onRefresh,
  expiryDates
}: IUserViewProps) => {
  const today = new Date();
  today.setHours(13, 30, 0, 0);
  const indexKeys: any = {
    Nifty: "NIFTY 50",
    "Bank Nifty": "NIFTY BANK",
    "Fin Nifty": "NIFTY FINANCIAL SERVICES",
  };
  const indexData = data.indices.filter(
    (val) => val.index === indexKeys[indexName]
  )[0];
  
  const [view, setView] = useState({
    viewType: ViewType.Up,
    expiryDate: "",
  });

  let [target, setTarget] = useState<any>({
    from: 0,
    to: 0,
    allowedBreakeven: 0,
  });

  const viewTypes = Object.keys(ViewType)
    .filter((val) => isNaN(Number(val)) === false)
    .map((key) => (ViewType as any)[key])
    .map((val) => {
      return { field: val };
    });
  const handleViewTypeChanged = (value: any) => {
    view.viewType = (ViewType as any)[value.field];
    setView({ ...view });
    target = getAllowedBreakeven(view.viewType, view.expiryDate);
    setTarget({ ...target });
    onViewUpdated();
  };
  const handleExpiryChanged = useCallback((value: any) => {
    view.expiryDate = value;
    target = getAllowedBreakeven(view.viewType, view.expiryDate);
    setTarget({ ...target });
    setView({ ...view });
    onViewUpdated();
  }, []);
  const handleFromTargetChanged = (event: any) => {
    const value = parseFloat(event.target.value);
    if (value) {
      target.from = value;
      setTarget({ ...target });
      onViewUpdated();
    }
  };
  const handleToTargetChanged = (event: any) => {
    const value = parseFloat(event.target.value);
    if (value) {
      target.to = value;
      setTarget({ ...target });
      onViewUpdated();
    }
  };
  const onViewUpdated = () => {
    setTimeout(() => {
      onViewSelected({ ...view, ...target });
    }, 120);
  };

  useEffect(() => {
    if (view.expiryDate === "") {
      handleExpiryChanged(expiryDates[0]);
    }
  }, [expiryDates, handleExpiryChanged, view.expiryDate]);

  const renderInput = (value: number, handler: any, key: string) => {
    return (
      <input
        key={key}
        style={{ width: "6ch" }}
        min={-4}
        max={4}
        type="number"
        defaultValue={value}
        onChange={handler}
      />
    );
  };

  const renderTarget = () => {
    if (isFinite(target.from) && isFinite(target.to)) {
      return (
        <span>
          <b>
            {renderInput(target.from, handleFromTargetChanged, "from")}%{"  "}
            to
            {"  "}
            {renderInput(target.to, handleToTargetChanged, "to")}%
          </b>
        </span>
      );
    }
    if (isFinite(target.to))
      return (
        <span>
          <b>Above {renderInput(target.to, handleToTargetChanged, "to")}%</b>
        </span>
      );
    return (
      <span>
        <b>
          Below {renderInput(target.from, handleFromTargetChanged, "from")}%
        </b>
      </span>
    );
  };
  return (
    <div style={{textAlign: 'center'}}>
      <img
        alt="refresh"
        onClick={onRefresh}
        className="refresh-icon"
        src={refreshIcon}
        width="20px"
        height="20px"
      />
      {indexData && (
        <div
          className={
            (indexData.variation < 0 ? "text-danger" : "text-success") +
            " e-field e-index-live-data"
          }
        >
          {indexName} {indexData.last}
          {", "}
          {indexData.percentChange}%
        </div>
      )}
      <div className="e-field">
        View on {indexName}
        <MultiSelectDropdown
          inline={true}
          className="e-normal-field"
          field="field"
          defaultValue={viewTypes[0]}
          dataSource={viewTypes}
          selectionChanged={handleViewTypeChanged}
        ></MultiSelectDropdown>
      </div>

      <div className="e-field">Expected Target: {renderTarget()}</div>

      <div className="e-field">
        Expiry Date
        <MultiSelectDropdown
          inline={true}
          className="e-normal-field"
          field=""
          defaultValue={expiryDates[0]}
          dataSource={expiryDates}
          selectionChanged={handleExpiryChanged}
        ></MultiSelectDropdown>
      </div>
    </div>
  );
};

export default UserView;
